import { getDiscountAmount } from '../price';
import { AFFILIATION_NAME_OPERATOR } from './helpers';

import type { TypeGTMProduct } from '@/types';

export const normalizeAlgoliaItem = (
  item: any,
  itemListId?: string,
  itemListName?: string,
  index?: number,
) => {
  let regularPrice = item.regular_price;
  let salePrice = item.sale_price;

  if (item.variations.length > 0) {
    regularPrice = item.variations[0].regular_price;
    salePrice = item.variations[0].sale_price;
  }

  const discount = item.on_sale
    ? Number.parseFloat(getDiscountAmount(regularPrice, salePrice).toFixed(2))
    : null;

  // TODO: cuando se implmente el buy box esto no servirá porque puede haber varios sellers
  let seller = AFFILIATION_NAME_OPERATOR;
  if (item?.seller[0] !== 'BigCrafters') {
    seller = item?.seller[0] ?? null;
  }

  let itemToAdd: TypeGTMProduct = {
    item_id: item.sku,
    item_name: item.name,
    // TODO: cuando se implmente el buy box esto no servirá porque puede haber varios sellers
    affiliation: seller,
    coupon: null,
    currency: 'EUR',
    discount,
    index: index ?? null,
    item_brand: Array.isArray(item?.marca) ? item.marca[0] : null,
    item_list_id: itemListId !== undefined ? itemListId : null,
    item_list_name: itemListName !== undefined ? itemListName : null,
    item_variant: null,
    price: regularPrice,
    quantity: 1,
  };

  if (item.tags.length > 0) {
    let categories: {
      [key: string]: string;
    } = {};

    for (let i = 0; i < item.tags.length; ++i) {
      const catLabel = i === 0 ? 'item_category' : `item_category${i + 1}`;

      categories = {
        ...categories,
        [catLabel]: item.tags[i].name,
      };
    }

    itemToAdd = { ...itemToAdd, ...categories };
  }

  return itemToAdd;
};
